import styled from 'styled-components';

const Svg = styled.svg``;
const Defs = styled.defs``;
const LinearGradient = styled.linearGradient``;
const Stop = styled.stop``;
const Rect = styled.rect``;
const Circle = styled.circle``;

export {Circle, Defs, LinearGradient, Rect, Stop, Svg};
